import React from 'react';

import IndexPaginationNav from 'buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import MembersIndexCard from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCard';

const UserFollowingList = ({ followingList, activeFollowedUsersCount, canViewUserDetails }) => {
  if (!followingList) return <div>You are not following any members.</div>;
  return (
    <div>
      {followingList.map(({ node }) => (
        <div data-test="following-card" key={node.user.id}>
          <MembersIndexCard node={node} canViewUserDetails={canViewUserDetails} />
        </div>
      ))}
      <IndexPaginationNav
        resultCount={activeFollowedUsersCount}
        resultLength={followingList.length}
        resultsPerPage={20}
      />
    </div>
  );
};

export default UserFollowingList;
